import React from "react";
import {Card, Col, Row} from "react-bootstrap";
import MeasurementText from "../MeasurementText/MeasurementText";
import {getMonthLabel} from "../Utils/utils";

export default function TotalAlertingSystems(props) {

    const lastNDays = props.data.nLastDays;
    const totalAlertingSystems = props.data.alertingSystems.current;
    const lastMonthLabel = getMonthLabel(props.data.alertingSystems.lastMonthDate);
    const lastMonthAlerts = props.data.alertingSystems.lastMonthValue;
    const percentOfTotal = props.data.alertingSystems.increaseValue;
    const positivePercentOfTotal = percentOfTotal < 0 ? percentOfTotal * -1 : percentOfTotal;

    return (
        <Card style={{height: '272px'}}>
            <Card.Body>
                <Card.Title className={'bold-title'}>Total Alerting Systems</Card.Title>
                <Card.Subtitle className={'text-muted'}>Last {lastNDays} Days</Card.Subtitle>
                <Card.Text style={{marginTop: '18px'}}>
                    <Row>
                        <Col md={6} className={'measurement-text'}>
                            <p>{totalAlertingSystems.toLocaleString()}</p>
                        </Col>
                    </Row>
                </Card.Text>
                <hr/>
                <Card.Text>
                    <Row style={{marginTop: '18px'}}>
                        <Col md={5}>
                            <Card.Subtitle className={'text-muted'}>{lastMonthLabel}</Card.Subtitle>
                        </Col>
                        <Col md={7}>
                            <Card.Subtitle className={'text-muted'}>% Of Total Systems</Card.Subtitle>
                        </Col>
                    </Row>
                </Card.Text>
                <Card.Text>
                    <Row style={{marginTop: '4px'}}>
                        <Col md={5}>
                            <Row>
                                <Col md={6} className={'measurement-text'}>
                                    <p>{lastMonthAlerts.toLocaleString()}</p>
                                </Col>
                            </Row>
                        </Col>
                        <Col md={7} className={'percentage-value'}>
                            <Card.Text style={{textAlign: 'center'}}>{positivePercentOfTotal || 0}%</Card.Text>
                        </Col>
                    </Row>
                </Card.Text>
            </Card.Body>
        </Card>
    )
}